import React, { useEffect, useState } from "react";
import "./admin.css";
import { MainHeaderr } from "../../Components/mainHeader/HeaderMain";


// services
import { AddNewAdmin } from "../../Components/Service/data";
import { LogInData } from "../../Components/Service/data";
import { IfDefaultAdmin } from "../../Components/Service/data";
import { ResetAdminMainData } from "../../Components/Service/data";








export const Admin = () =>{

    const [ loadingReset , setloadingReset ] = useState(false);
    const [ loadingLogIn , setloadingLogIn ] = useState(false);
    const [ loadingOut , setloadingOut ] = useState(false);
    const [ loadingAddNew , setloadingAddNew ] = useState(false);

    useEffect(()=>{
        if (localStorage.getItem("isLogged") == "true") {
            // Elements
            const IsLoggged = document.getElementById("IsLoggged");
            IsLoggged.classList.add("IsLogggedActive");
        }else{
            // اذا مسجل دخول مافي داعي ليفحص اذا كان الاساسي
            const OneRestAdminData = document.getElementById("OneRestAdminData");
            IfDefaultAdmin().then( res =>{
                if (res.DefaultAdmin == "true") {
                    OneRestAdminData.style.display = "block";
                }
            });
        }
    });

    

    const ondragenter = (event) =>{
        if (event.key == "Enter") {
            LogInRequest();
        }
    }


    const toggelScreensLogin = (event) => {
        const toAdminScroll = document.getElementById("toAdminScroll");
        const AdminLogINCard = document.getElementById("AdminLogINCard");

        if (event.target.id == "ToAddNew") {
            toAdminScroll.style.transform = "translateX(-100%)";
            AdminLogINCard.classList.add("AdminLogINCardAdd");
        }else{
            toAdminScroll.style.transform = "translateX(0)";
            AdminLogINCard.classList.remove("AdminLogINCardAdd");
        }
    }

    
    const AddNewAdminHand = () =>{
        setloadingAddNew(true);
        // Inputs
        const userName = document.querySelector("#userNameAdd");
        const password = document.querySelector("#passwordAdd");
        const AdminMainPassword = document.querySelector("#AdminMainPassword");
        // Values
        const userNameValue = userName.value;
        const passwordValue = password.value;
        const AdminMainPasswordValue = AdminMainPassword.value;

        if (userNameValue.length > 1 && passwordValue.length > 1 && AdminMainPasswordValue.length > 1 ) {

            setTimeout(() => {
                AddNewAdmin(userNameValue , passwordValue , AdminMainPasswordValue ).then(res =>{

                    if (res == true) {
                        setloadingAddNew(false);
                        ShowAlert("A new administrator has been added successfully" , 3500);
                    }else{
                        setloadingAddNew(false);
                        ShowErrorAlert("Sorry, you do not have admin privileges" , 2000);
                    }
                });
            }, 500);
        }


    }



    const ResetAdminData = () =>{
        setloadingReset(true);

        const passwordReset = document.querySelector("#passwordReset");
        const userNameReset = document.querySelector("#userNameReset");
        const DefaultPassReset = document.querySelector("#DefaultPassReset");

        const userNameValue = userNameReset.value;
        const PassValue = passwordReset.value;
        const DefaultPassValue = DefaultPassReset.value;

        setTimeout(() => {
            ResetAdminMainData( userNameValue , PassValue , DefaultPassValue).then( res =>{
                setloadingReset(false);
                if (res == "ok") {
                    const OneRestAdminData = document.getElementById("OneRestAdminData");
                    OneRestAdminData.style.display = "none";
                }
            });
        }, 500);
    }

    const LogInRequest = () =>{
        // Elements
        const IsLoggged = document.getElementById("IsLoggged");
        // Inputs
        const userNameLog = document.getElementById("userNameLog");
        const passwordLog = document.getElementById("passwordLog");
        // Values
        const userNameLogValue = userNameLog.value;
        const passwordLogValue = passwordLog.value;

        if (userNameLogValue.length > 0 && passwordLogValue.length > 0) {
            setloadingLogIn(true);
            setTimeout(() => {
                LogInData( userNameLogValue , passwordLogValue).then( res => {
                    setloadingLogIn(false);
                    if (res == "True") {
                        IsLoggged.classList.add("IsLogggedActive");
                        localStorage.setItem("isLogged" , true);
                    }else{
                        IsLoggged.classList.remove("IsLogggedActive");
                        ShowErrorAlert("Sorry, You Are Not A Admin!" , 3000);
                    }
                });
            }, 500);
        }
    }


    const LogOut = () =>{
        localStorage.removeItem("isLogged");
        if (localStorage.getItem("isLogged") != "true") {
            const IsLoggged = document.getElementById("IsLoggged");
            IsLoggged.classList.remove("IsLogggedActive");
        }
    }

    const goHome = () =>{
        window.location.href = "/";
    }


    const ShowErrorAlert = (Message , waitingTime) =>{
        const AlertError = document.getElementById("AlertError");
        const AlertMessage = document.getElementById("AlertMessage");

        AlertMessage.innerHTML = Message;
        AlertError.style.visibility = "visible";

        setTimeout(() => {
            AlertError.style.visibility = "hidden";
        }, waitingTime);
    }

    const ShowAlert = (Message , waitingTime) =>{
        const Alert = document.getElementById("Alert");
        const AlertMessage = document.getElementById("AlertMessage2");

        AlertMessage.innerHTML = Message;
        Alert.style.visibility = "visible";

        setTimeout(() => {
            Alert.style.visibility = "hidden";
        }, waitingTime);
       
    }


 




    return(
        <div className="mainBodyAdmin d-flex justify-content-center align-items-center">

            <MainHeaderr />

            <div className="AdminLogINCard" id="AdminLogINCard">
            <div id="toAdminScroll" className="d-flex justify-content-start align-items-center">

                <div className="loginScreen" id="loginScreen">
                    <div className="loginHeader">
                        <p className="TitleFormLogIn">
                            Admin Login
                        </p>
                    </div>

                    <div className="FormBody">
                        <div className="inputContainer">
                            <p className="inputLable">User Name</p>
                            <input type="email" className="inputStyle" id="userNameLog" />
                        </div>

                        <div className="inputContainer">
                            <p className="inputLable">Password</p>
                            <input type="password" className="inputStyle" id="passwordLog" onKeyDown={ondragenter} />
                        </div>

                        <div className="loginBTNContainer d-flex justify-content-center align-items-center" onClick={LogInRequest} >
                            <span className="LabelBtnLogin"   >
                                { loadingLogIn ? "" : "Login"}
                                { loadingLogIn ? <div class="spinner-border text-light" role="status"></div> : ""}
                            </span>
                        </div>
                    </div>

                    <div className="FormFootr">
                        <span className="jjhzseerjld" id="">
                            Password forget?
                        </span>

                        <span className="jjhzseerjld" id="ToAddNew" onClick={toggelScreensLogin} >
                            New Admin
                        </span>
                    </div>
                </div>




                {/* Add New */}
                <div className="AddNewScreen" id="AddNewScreen">
                    <div className="loginHeader">
                        <p className="TitleFormLogIn">
                            Add new Admin
                        </p>
                    </div>

                    <div className="FormBody">
                        <div className="inputContainer">
                            <p className="inputLable">User Name</p>
                            <input type="email" className="inputStyle" id="userNameAdd" />
                        </div>

                        <div className="inputContainer">
                            <p className="inputLable">Password</p>
                            <input type="password" className="inputStyle" id="passwordAdd" />
                        </div>


                        <div className="inputContainer">
                            <p className="inputLable">Main Admin Password</p>
                            <input type="password" className="inputStyle" id="AdminMainPassword" />
                        </div>

                        <div className="loginBTNContainer d-flex justify-content-center align-items-center" onClick={AddNewAdminHand}>
                            <spa className="LabelBtnLogin" >
                                { loadingAddNew ? <div class="spinner-border text-light" role="status"></div> : ""}
                                { loadingAddNew ? "" : "Add"}
                            </spa>
                        </div>
                    </div>

                    <div className="FormFootr">
                        <span className="jjhzseerjld" onClick={toggelScreensLogin} >
                            LogIn
                        </span>
                    </div>
                </div>

            </div>


            {/* Reset */}
            <div className="AddNewScreen" id="OneRestAdminData">
                <div className="loginHeader">
                    <p className="TitleReset">
                        Hello, When you login for the first time, you must reset the default password and E-Mail.
                    </p>
                </div>

                <div className="FormBody">
                    <div className="inputContainer">
                        <p className="inputLable">New User Name</p>
                        <input type="email" className="inputStyle" id="userNameReset" />
                    </div>

                    <div className="inputContainer">
                        <p className="inputLable">New Password</p>
                        <input type="password" className="inputStyle" id="passwordReset" />
                    </div>

                    <div className="inputContainer">
                        <p className="inputLable">Default Password</p>
                        <input type="password" className="inputStyle" id="DefaultPassReset" />
                    </div>

                    <div className="loginBTNContainer d-flex justify-content-center align-items-center" onClick={ResetAdminData}>
                        <span className="LabelBtnLogin">
                            { loadingReset ? "" : "Reset"}  
                        </span>
                        <span>
                            { loadingReset ? <div class="spinner-border text-light" role="status"></div> : ""}
                        </span>
                    </div>
                </div>

                <div className="FormFootr">
                </div>

            </div>





            <div className="IsLoggged d-flex flex-column justify-content-between" id="IsLoggged">
                <div className="loginHeader">
                    <p className="TitleFormLogIn">
                        You are logged in successfully  <span className="Sa7Sa7">&#9989;</span> 
                    </p>
                </div>

                <div className="BodyDoneLooged">

                    <div className="loginBTNContainer BTNDoneLooged d-flex justify-content-center align-items-center" onClick={goHome}>
                        <span className="LabelBtnLogin">
                            Go Home
                        </span>
                    </div>


                    <div className="loginBTNContainer BTNDoneLooged d-flex justify-content-center align-items-center" onClick={LogOut}>
                        <span className="LabelBtnLogin">
                            { loadingOut ? "" : "LogOut"}  
                        </span>
                        <span>
                            { loadingOut ? <div class="spinner-border text-light" role="status"></div> : ""}
                        </span>
                    </div>

                </div>
            </div>

            </div>

            <div className="alert myAlert alert-danger d-flex align-items-center" role="alert" id="AlertError" >
                <div className="" id="AlertMessage">
                    An example danger alert with an icon
                </div>
            </div>


            <div class="alert myAlert alert-primary d-flex align-items-center" role="alert" id="Alert">
            <div id="AlertMessage2">
                An example alert with an icon
            </div>
        </div>
        </div>
    );
}

